import styled from 'styled-components'

export const HeaderLogoWrapper = styled.div`
  & svg {
    display: block;
  }
`
